export function getBeds(datum) {
    const data = datum.floor_plans;
    if(!data) return [];
    if(data.length <1) return [];
    var bhks_full = [...new Set(data.map(p => p.bhk))];
    bhks_full = bhks_full.sort((f, s) => (parseFloat(f) < parseFloat(s))? -1 : 1)
    return bhks_full.filter(p => p ? true : false);
}